import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import ExecutingStageCellContent from "../components/ExecutingStageCellContent";

function executingStage({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.ExecutingStage,
		(item) => <ExecutingStageCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default executingStage;
